import { createSlice, PayloadAction, createSelector } from "@reduxjs/toolkit";
import { Branch } from "./branchs.type";
import { RootState } from "@/app/app.store";

interface BranchState {
  branch?: Branch;
  sidebar: boolean;
}

const initialState: BranchState = {
  branch: undefined,
  sidebar: false,
};

const branchSlice = createSlice({
  name: "branch",
  initialState,
  reducers: {
    setBranch: (state, action: PayloadAction<Branch>) => {
      state.branch = action.payload;
    },
    clearBranch: (state) => {
      state.branch = undefined;
    },
    toggleSidebar: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        state.sidebar = action.payload;
      }else{
        state.sidebar = !state.sidebar;
      }
      
    },
  },
});

export const { setBranch, clearBranch, toggleSidebar } = branchSlice.actions;

export default branchSlice.reducer;

// Selector para obtener la branch del estado
export const selectBranchState = (state: RootState) => state.branch;

export const selectBranch = createSelector(
  selectBranchState,
  (branchState) =>  branchState.branch
);
